import React, {Component} from 'react';

import styles from '../../../static/css/articleStyleModules/A2HShelpArticle.module.scss';


import shereButtonImage from '../../../static/img/shereButton.png';
import a2hsButtonImage from '../../../static/img/addToHomeScreen.png';

import a2hsBannerImage from '../../../static/img/a2hsBanner.png';

export default class A2HSHelpArticle extends Component {

    constructor(props){
        super(props);
        this.state = {
            page:0,
        }
    }

    goToTutorial = () => {
        this.props.onChangeArticle('tutorial');
    }



    render() {

        const A2HSPage = (
            <div className={styles['pageArea']} 
            key={'A2HSPage'}>
              <h2>ホーム画面に追加しよう！</h2>
              <p>『ありがとログ』は<b>このwebページをスマホの「ホーム画面に追加」</b>することで、普通のスマホアプリと同様に使えるようになります。</p>
              <h3>iPhoneをお使いの方</h3>
              <p>
                <span><b>safari</b>からこのページにアクセスして、下のタブバーにある共有ボタンをタップして、「ホーム画面に追加」を選んでタップしてください。<br></br>iOSのバージョンが<b>11.3以上</b>でないと正常に動作しない可能性がありますのでご注意ください</span>
              </p>
              <div className={styles['imageFlex']}>
                <div className={styles['imageBox']}>
                  <img src={shereButtonImage} alt="shereButton" />
                  <span>共有ボタン</span>
                </div>
                <div className={styles['imageBox']}>
                  <img src={a2hsButtonImage} alt="A2HSbutton" />
                </div>
              </div>
              <h3>androidスマホをお使いの方</h3>
              <p>
                <span>このページを一旦閉じて、5分以上間隔を開けて再度開くと、画面下部にホーム画面への追加ボタンが表示されます。</span>
              </p>
              <div className={styles['imageBlock']}>
                <img src={a2hsBannerImage} alt="A2HSbanner" />
              </div>
              <p>
                <span>または、Google Chromeで開き、右上にある『メニューアイコン』をタップします。表示されたメニューから『ホーム画面に追加』をタップしてください。</span>
              </p>

              {this.props.singleHelp !== true && 
                  <div className={styles['pageBlockButton'] + ' touchActiveDark'}
                  onClick={() => this.goToTutorial()}
                  >とりあえず試してみる！</div>
              }

              {this.props.singleHelp === true && 
                  <div className={styles['pageBlockButton'] + ' touchActiveDark'}
                  onClick={() => this.props.onCloseButtonClick()}
                  >わかった</div>
              }

            </div>
        )

        const pageComponentArray = [
            A2HSPage,
        ]

        return (
            <div className={styles['helpArticleArea']}>
              {pageComponentArray.map((value,index) => {
                  return (this.state.page === index && value)
              })}
            </div>
        )
    }

};